import * as v from "valibot";
import { pageRequest, pageResponse } from "../paging.dto";
import { adminUserIdRequest } from "./users.dto";

export const adminFollowDto = v.object({ authorAlias: v.string(), createdAt: v.number() });
export type AdminFollow = v.InferOutput<typeof adminFollowDto>;

export const adminFollowsResponse = { follows: v.array(adminFollowDto) };

export const adminFollowRequest = {
  ...adminUserIdRequest,
  alias: v.pipe(v.string(), v.minLength(1), v.maxLength(100)),
};

export const adminUserArticleDto = v.object({
  authorAlias: v.string(),
  articleId: v.string(),
  /** Empty when the article row is gone. */
  title: v.string(),
  /** When the user read it, or added it to the collection. */
  at: v.number(),
});
export type AdminUserArticle = v.InferOutput<typeof adminUserArticleDto>;

export const listAdminReadsRequest = { ...adminUserIdRequest, ...pageRequest };
export const listAdminReadsResponse = { reads: v.array(adminUserArticleDto), ...pageResponse };

export const adminCollectionDto = v.object({
  id: v.string(),
  name: v.string(),
  isDefault: v.boolean(),
  articleCount: v.number(),
  createdAt: v.number(),
});
export type AdminCollection = v.InferOutput<typeof adminCollectionDto>;

export const adminCollectionsResponse = { collections: v.array(adminCollectionDto) };

export const listAdminCollectionItemsRequest = {
  ...adminUserIdRequest,
  collectionId: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
  ...pageRequest,
};
export const listAdminCollectionItemsResponse = { items: v.array(adminUserArticleDto), ...pageResponse };
